var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.2,39.1c32.6,0,65.3,0,97.9,0c13.2,0,21.4,8.2,21.4,21.3c0,43.5,0,86.9,0,130.4c0,13.2-8.2,21.4-21.4,21.4 c-65.5,0-131.1,0-196.6,0c-12.8,0-21.1-8.3-21.1-21.1c0-43.6,0-87.3,0-130.9c0-12.8,8.3-21.1,21.1-21.1 C62.5,39.1,95.3,39.1,128.2,39.1L128.2,39.1z M239.3,166.8v-2.6c0-34.7,0-69.4,0-104.1c0-8.1-4.7-12.7-12.9-12.7 c-65.6,0-131.2,0-196.8,0c-8.3,0-12.9,4.6-12.9,12.9c0,34.6,0,69.2,0,103.8v2.7L239.3,166.8L239.3,166.8z M239.3,175.4H16.7 c0,5.2,0,10.1,0,15.1c0,9.2,4.3,13.6,13.5,13.6c65.2,0,130.4,0,195.5,0c0.9,0,1.9,0,2.8,0c5.7-0.4,10.4-5,10.6-10.7 C239.4,187.4,239.3,181.5,239.3,175.4L239.3,175.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.2,107.1c0-9.1,0-18.2,0-27.3c0-4.9,3.1-6.6,7.3-4.2c15.8,9.1,31.6,18.2,47.4,27.4c4.1,2.3,4,5.9-0.1,8.3 c-15.8,9.1-31.6,18.3-47.4,27.4c-4.2,2.4-7.2,0.6-7.2-4.2C99.1,125.3,99.2,116.2,99.2,107.1L99.2,107.1z M107.5,128.5 c12.5-7.2,24.5-14.2,37-21.3c-12.5-7.2-24.7-14.2-37-21.4C107.5,85.8,107.5,128.5,107.5,128.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,193.7c-2.2,0-4.1-1.8-4.1-4.1c0-2.3,1.8-4.1,4-4.1c2.2,0,4.1,1.8,4.1,4.1C36,191.8,34.2,193.7,32,193.7 L32,193.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,189.6c0,2.3-1.8,4.1-4,4.2c-2.2,0-4.1-1.8-4.1-4.1s1.8-4.1,4-4.2S52.4,187.3,52.5,189.6L52.5,189.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.7,189.5c0.1,2.3-1.7,4.1-3.9,4.2c-2.2,0.1-4.1-1.7-4.1-4c-0.1-2.3,1.7-4.1,3.9-4.2 C209.8,185.5,211.6,187.3,211.7,189.5L211.7,189.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.2,189.5c0,2.3-1.8,4.1-4,4.2s-4.1-1.8-4.1-4c0-2.3,1.7-4.1,4-4.2C226.3,185.5,228.1,187.3,228.2,189.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.3,185.5h-57.2v-3c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1v3H66.7c-2.3,0-4.1,1.8-4.1,4.1l0,0 c0,2.3,1.8,4.1,4.1,4.1h57.2v2.7c0,2.3,1.8,4.1,4.1,4.1s4.1-1.8,4.1-4.1v-2.7h57.2c2.3,0,4.1-1.8,4.1-4.1l0,0 C193.4,187.3,191.6,185.5,189.3,185.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c5fdf20f4507ac7ae2b983f136bf951b.svg";
export { ForwardRef as ReactComponent };